import StorageRepository from "../../../domain/fundamentals/storage/StorageRepository";

export default class LocalStorageDataSource implements StorageRepository {
  public deleteBy(key: string): void {
    localStorage.removeItem(key);
  }

  public findBy(key: string): string {
    const item: string | null = localStorage.getItem(key);
    return item === null ? "" : item;
  }

  public save(key: string, target: string): void {
    localStorage.setItem(key, target);
  }

}